import { useSignal } from "@preact/signals-react";
import isBlank from "@sedan-utils/is-blank";
import { DomUtil } from "../../base/util/DomUtil";
import { useUpdate } from "ahooks";
import { CDNPathUtil } from "imagica-corekit/dist/base/util/CDNPathUtil";
import React, { useEffect, useRef } from "react";
import WaveSurfer from "wavesurfer.js";
import styles from "./Audio.module.scss";
import { AudioLoading } from "../components/AudioLoading/AudioLoading";
import cls from "classnames";
export function Audio(_ref) {
  var _waveSignal$value$get2, _waveSignal$value9;
  var createBlobUrl = _ref.createBlobUrl,
    textAreaValue = _ref.textAreaValue,
    loading = _ref.loading;
  var audioRef = useRef(null);
  var isPlaying = useSignal(false);
  var currentTime = useSignal(null);
  var waveSignal = useSignal(null);
  var isMuted = useSignal(false);
  var containerRef = useRef(null);
  var forceUpdate = useUpdate();
  function clickPlay() {
    var _waveSignal$value;
    if (!((_waveSignal$value = waveSignal.value) !== null && _waveSignal$value !== void 0 && _waveSignal$value.isPlaying())) {
      var _waveSignal$value2;
      (_waveSignal$value2 = waveSignal.value) === null || _waveSignal$value2 === void 0 || _waveSignal$value2.play();
    } else {
      var _waveSignal$value3;
      (_waveSignal$value3 = waveSignal.value) === null || _waveSignal$value3 === void 0 || _waveSignal$value3.pause();
    }
  }
  // //转换为01:21 格式
  function secondToTimeStr(sec) {
    var hours = Math.floor(sec / 3600);
    var minutes = Math.floor((sec - 3600 * hours) / 60);
    var seconds = Number((sec - 3600 * hours - minutes * 60).toFixed());
    var hourStr = hours > 0 ? "".concat(hours, ":") : "";
    var minuteStr = minutes > 0 ? "".concat(minutes, ":") : "00:";
    var secStr = seconds > 0 ? "".concat(seconds) : "00";
    if (!isBlank(hourStr)) {
      if (minuteStr.length == 1) minuteStr = "0" + minuteStr + ":";
    }
    if (!isBlank(minuteStr)) {
      if (secStr.length == 1) secStr = "0" + secStr;
    }
    return hourStr + minuteStr + secStr;
  }
  //
  function audioFileName() {
    var _textAreaValue$name;
    return (_textAreaValue$name = textAreaValue === null || textAreaValue === void 0 ? void 0 : textAreaValue.name) !== null && _textAreaValue$name !== void 0 ? _textAreaValue$name : "";
  }
  //
  useEffect(function () {
    var _createBlobUrl$object;
    if (!containerRef.current) return;
    if (isBlank((_createBlobUrl$object = createBlobUrl === null || createBlobUrl === void 0 ? void 0 : createBlobUrl.objectURL) !== null && _createBlobUrl$object !== void 0 ? _createBlobUrl$object : "")) return;
    var isDark = audioRef.current ? DomUtil.hasTheme(audioRef.current, "dark") : false;
    currentTime.value = 0;
    isPlaying.value = false;
    var wavesurfer = WaveSurfer.create({
      container: containerRef.current,
      height: "auto",
      waveColor: isDark ? "#48484B" : "#e6e7e9",
      progressColor: isDark ? "#ffffff" : "#12192B",
      // play color
      url: createBlobUrl === null || createBlobUrl === void 0 ? void 0 : createBlobUrl.objectURL,
      barAlign: "bottom",
      cursorWidth: 0,
      fillParent: true,
      // Set a bar width
      barWidth: 2,
      // Optionally, specify the spacing between bars
      barGap: 6,
      // And the bar radius
      barRadius: 2
    });
    waveSignal.value = wavesurfer;
    var subscriptions = [wavesurfer.on("play", function () {
      return isPlaying.value = true;
    }), wavesurfer.on("pause", function () {
      return isPlaying.value = false;
    }), wavesurfer.on("timeupdate", function (ct) {
      return currentTime.value = ct;
    }), wavesurfer.on("decode", function () {
      return forceUpdate();
    })];
    return function () {
      subscriptions.forEach(function (unsub) {
        return unsub();
      });
      wavesurfer.destroy();
    };
  }, [containerRef, createBlobUrl === null || createBlobUrl === void 0 ? void 0 : createBlobUrl.objectURL, audioRef]);
  function currentTimeStr() {
    var _waveSignal$value4, _currentTime$value, _waveSignal$value$get, _waveSignal$value5;
    if (!((_waveSignal$value4 = waveSignal.value) !== null && _waveSignal$value4 !== void 0 && _waveSignal$value4.getDuration())) return "";
    var currentStr = secondToTimeStr((_currentTime$value = currentTime.value) !== null && _currentTime$value !== void 0 ? _currentTime$value : 0);
    if (isBlank(currentStr) && ((_waveSignal$value$get = (_waveSignal$value5 = waveSignal.value) === null || _waveSignal$value5 === void 0 ? void 0 : _waveSignal$value5.getDuration()) !== null && _waveSignal$value$get !== void 0 ? _waveSignal$value$get : 0) > 0) {
      return "00:00";
    }
    return currentStr;
  }
  function durationStr() {
    var _waveSignal$value6;
    var duration = (_waveSignal$value6 = waveSignal.value) === null || _waveSignal$value6 === void 0 ? void 0 : _waveSignal$value6.getDuration();
    if (!duration) return "";
    return secondToTimeStr(duration);
  }
  function clickVolume() {
    var _waveSignal$value7, _waveSignal$value8;
    isMuted.value = !((_waveSignal$value7 = waveSignal.value) !== null && _waveSignal$value7 !== void 0 && _waveSignal$value7.getMuted()) || false;
    (_waveSignal$value8 = waveSignal.value) === null || _waveSignal$value8 === void 0 || _waveSignal$value8.setMuted(isMuted.value);
  }
  if (loading == true) return /*#__PURE__*/React.createElement(AudioLoading, null);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.box,
    ref: audioRef
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.topBox
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.playBox
  }, /*#__PURE__*/React.createElement("img", {
    className: styles.play_icon,
    src: isPlaying.value ? CDNPathUtil.getFilePath("audio_pause.png") : CDNPathUtil.getFilePath("audio_play.png"),
    onClick: function onClick() {
      return clickPlay();
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.playTimeBox
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.fileName
  }, audioFileName()), /*#__PURE__*/React.createElement("span", {
    className: styles.currentTime
  }, currentTimeStr()), /*#__PURE__*/React.createElement("span", {
    className: styles.totalTime
  }, (((_waveSignal$value$get2 = (_waveSignal$value9 = waveSignal.value) === null || _waveSignal$value9 === void 0 ? void 0 : _waveSignal$value9.getDuration()) !== null && _waveSignal$value$get2 !== void 0 ? _waveSignal$value$get2 : 0) > 0 ? " / " : "") + durationStr()))), /*#__PURE__*/React.createElement("img", {
    className: styles.voice_Img,
    src: isMuted.value ? CDNPathUtil.getFilePath("mute.png") : CDNPathUtil.getFilePath("voice.png"),
    onClick: clickVolume
  })), /*#__PURE__*/React.createElement("div", {
    className: cls(styles.waveform_box, styles.waveformMargin),
    ref: containerRef
  }));
}